import { z } from 'zod';
import { componentStyleSchema } from '../component-catalog.js';
const commonOptionals = {
    queryConfig: z.record(z.string(), z.unknown()).optional(),
    minimized: z.boolean().optional(),
    displayConfig: z.record(z.string(), z.unknown()).optional(),
    annotations: z.array(z.record(z.string(), z.unknown())).optional(),
    style: componentStyleSchema.optional(),
};
const propsSchema = z
    .object({
    sourceDataset: z.string(),
    mapping: z.object({ xValues: z.string(), yValues: z.string() }).strict(),
    ...commonOptionals,
})
    .strict();
export const scatterPlotDefinition = {
    type: 'ScatterPlot',
    category: 'data',
    propsSchema,
    isDataBacked: true,
    columnRefManifest: ['xValues', 'yValues'],
    needsMeasuredDims: true,
    defaultMinHeight: 200,
    description: 'Scatter plot over a dataset. Props: sourceDataset (required), mapping ({ xValues: string, yValues: string }).',
};
//# sourceMappingURL=ScatterPlot.js.map